import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-[#0c241a] ${className}`} data-id="element-330">
      <div className="container mx-auto px-4" data-id="element-331">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px] md:text-2xl" data-id="element-332">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-333">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-[#06140d]/70 p-6 rounded-2xl shadow-lg border border-[#1a3d2c] flex flex-col h-full" data-id="element-334">
              <div className="flex items-center gap-1 mb-4" data-id="element-335">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-slate-300 fill-slate-300" data-id="element-336" />)}
              </div>

              <p className="text-slate-300 italic mb-6 flex-grow" data-id="element-337">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-[#1a3d2c]/50" data-id="element-338">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-339">
                  {t.initials}
                </div>
                <div data-id="element-340">
                  <p className="font-bold text-white text-sm" data-id="element-341">{t.name}</p>
                  <p className="text-xs text-slate-400" data-id="element-342">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-slate-300/90 mt-0.5" data-id="element-343">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials: Testimonial[] = [{
  initials: 'MG',
  name: 'María G.',
  location: 'Docente de Energías Renovables · Escuela Técnica Nº 4 · Mendoza',
  text: 'Llevaba años armando mis propias planificaciones de energías renovables desde cero cada ciclo lectivo. Abrí el Tomo 1 y en 15 minutos tenía la planificación anual completa lista para presentar. No puedo creer que antes perdía días enteros haciendo esto.',
  color: 'bg-emerald-700'
}, {
  initials: 'RS',
  name: 'Roberto S.',
  location: 'Profesor de Física y Energías Renovables · Buenos Aires',
  text: 'El Banco de Evaluaciones me salvó el año. Tengo exámenes organizados por tema, tipo y nivel. Ya no busco más en internet preguntas que mis alumnos ya conocen de otros años.',
  color: 'bg-green-800'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Docente técnica · EEST · Neuquén',
  text: 'El Tomo 3 de Energía Eólica me permitió explicar el Atlas Eólico argentino y los casos de Patagonia con material concreto. Mis alumnos ahora hablan de hidrógeno verde como si fuera algo de su vida cotidiana.',
  color: 'bg-emerald-800'
}];
export const moreTestimonials: Testimonial[] = [{
  initials: 'PM',
  name: 'Pablo M.',
  location: '🏙️ Buenos Aires',
  text: 'Dos años armando el mismo material cada ciclo lectivo. Con el Megapack en una tarde tenía todo el año organizado. No lo puedo creer.',
  color: 'bg-green-900',
  pack: 'Megapack Energías Renovables'
}, {
  initials: 'RL',
  name: 'Rosa L.',
  location: '🏙️ Santa Fe',
  text: 'El Tomo 2 de Energía Solar me dio una secuencia tan clara que mis alumnos entendieron el sistema off-grid en una sola clase. Antes me llevaba tres.',
  color: 'bg-emerald-600',
  pack: 'Megapack Energías Renovables'
}, {
  initials: 'GF',
  name: 'Gonzalo F.',
  location: '🏙️ Tucumán',
  text: 'Con las Presentaciones Listas llegué al aula con una clase sobre hidrógeno verde completamente profesional. Mis alumnos pensaron que había hecho un curso especial.',
  color: 'bg-emerald-700',
  pack: 'Megapack + Mega Biblioteca'
}, {
  initials: 'AM',
  name: 'Andrea M.',
  location: '🏙️ Rosario',
  text: 'Cerré la planificación anual en 2 horas usando el Tomo 1. Antes me llevaba una semana entera y siempre me faltaba algo.',
  color: 'bg-green-800',
  pack: 'Megapack + Mega Biblioteca'
}, {
  initials: 'SV',
  name: 'Santiago V.',
  location: '🏙️ Córdoba',
  text: 'El Banco de Evaluaciones con clave me cambió la vida. Tengo exámenes diferentes para cada división y los corrijo en minutos.',
  color: 'bg-emerald-800',
  pack: 'Megapack Energías Renovables'
}];